import React, { useState, useEffect } from 'react'

// Antd
import { Button, Col, Drawer, Form, Input, Row, notification, Spin } from 'antd';
import { addCenter, editCenter } from '../../../../Constants/Api/functions/function';

const AddCenter = ({ setOpen, isOpen, handleGetAllCenters, editingCenter }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [api, contextHolder] = notification.useNotification();
    const [form] = Form.useForm();

    useEffect(() => {
        if (editingCenter) {
            form.setFieldsValue({
                centerName: editingCenter.centerName,
                centerAddress: editingCenter.centerAddress,
                email: editingCenter.email,
                website: editingCenter.website,
                fbLink: editingCenter.fbLink,
                phoneNumber: editingCenter.phoneNumber,
                contactPerson: editingCenter.contactPerson,
            });
        } else {
            form.resetFields();
        }
    }, [editingCenter, form]);

    const onFinish = async (values) => {
        Object.keys(values).forEach(key => (values[key] === undefined || values[key] === '') && delete values[key]);

        try {
            setIsLoading(true)

            let response;
            if (editingCenter) {
                // Edit mode - transform camelCase to PascalCase for backend
                const editData = {
                    CenterId: editingCenter.centerId,
                    CenterName: values.centerName,
                    CenterAddress: values.centerAddress,
                    Email: values.email,
                    Website: values.website,
                    FBLink: values.fbLink,
                    PhoneNumber: values.phoneNumber,
                    ContactPerson: values.contactPerson
                };
                response = await editCenter(editData);
                if (response) {
                    openNotificationWithIcon("success", "Center updated successfully")
                    closeAddCenterDrawer()
                    await handleGetAllCenters()
                } else {
                    openNotificationWithIcon("error", "Error updating center")
                }
            } else {
                // Add mode - transform camelCase to PascalCase for backend
                const addData = {
                    CenterName: values.centerName,
                    CenterAddress: values.centerAddress,
                    Email: values.email,
                    Website: values.website,
                    FBLink: values.fbLink,
                    PhoneNumber: values.phoneNumber,
                    ContactPerson: values.contactPerson
                };
                response = await addCenter(addData)
                if (response && response.status === 200) {
                    openNotificationWithIcon("success")
                    closeAddCenterDrawer()
                    await handleGetAllCenters()
                } else {
                    console.log("error", response?.data?.message)
                    openNotificationWithIcon("error", response?.data?.message)
                }
            }
        } catch (error) {
            console.log("error", error)
            openNotificationWithIcon("error", error)
        } finally {
            setIsLoading(false)
        }
    }

    const openNotificationWithIcon = (type, error) => {
        api[type]({
            message: type === "success" ? (editingCenter ? "Center Updated Successfully" : "Center Created Successfully") : "Error",
            description: type === "success" ? (editingCenter ? "Center has been updated successfully." : "Center has been created successfully.")
                : `There was an error. Please try again later. ${error}`
        });
    };

    const closeAddCenterDrawer = () => {
        setOpen(false)
        form.resetFields();
    }

    return (
        <div>
            {contextHolder}
            <Drawer
                title={editingCenter ? "Edit Center" : "Create new center"}
                width={720}
                onClose={closeAddCenterDrawer}
                open={isOpen}
                styles={{
                    body: {
                        paddingBottom: 80,
                    },
                }}
            >
                <Spin
                    spinning={isLoading}
                    tip={editingCenter ? "Updating center..." : "Creating center..."}
                >
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                    >
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="centerName"
                                    label="Center Name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter center name",
                                        },
                                    ]}
                                >
                                    <Input placeholder="Please enter center name" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="centerAddress"
                                    label="Center Address"
                                >
                                    <Input placeholder="Please enter center address" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="email"
                                    label="Email"
                                    rules={[
                                        {
                                            type: 'email',
                                            message: 'Please enter a valid email',
                                        }
                                    ]}
                                >
                                    <Input placeholder="Please enter email" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="website"
                                    label="Website"
                                >
                                    <Input placeholder="Please enter website URL" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="fbLink"
                                    label="Facebook Link"
                                >
                                    <Input placeholder="Please enter Facebook link" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="phoneNumber"
                                    label="Phone Number"
                                >
                                    <Input placeholder="Please enter phone number" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="contactPerson"
                                    label="Contact Person"
                                >
                                    <Input placeholder="Please enter contact person" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Button type="primary" htmlType="submit">
                                    {editingCenter ? "Update Center" : "Add Center"}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </Drawer>
        </div>
    )
}

export default AddCenter